import React, { Component } from "react";
import { Button } from "reactstrap";
import { Link } from "react-router-dom";
import moment from "moment";
import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";
import { connect } from "react-redux";
import style from "./InvoiceList.module.css";
import { fetchInvoiceList } from "../../../redux";
import ttmLoader from "../../../assets/images/ttm-loader.gif";
import { checkIfPermitted, Permissions } from "../../../services/RolePermissionService";
import { DatePicker } from "antd";
import invoiceIcon from "../../../assets/images/invoice-page-icon.svg";
import { formatNumberToCurrency } from "../../../utils/CommonUtil";
import { Modal, ModalHeader, ModalBody } from "reactstrap";
import api from "../../../utils/Api";

function dateFormatter(cell) {
  if (!cell) {
    return "";
  }
  return `${
    moment(cell).format("YYYY-MM-DD")
      ? moment(cell).format("YYYY-MM-DD")
      : moment(cell).format("YYYY-MM-DD")
  }`;
}

export class PatientInvoiceCash extends Component {
  constructor(props) {
    super(props);

    this.state = {
      searchKey: "",
      page: 1,
      sortName: undefined,
      sortOrder: undefined,
      sortBy: "",
      dateFrom: "",
      dateTo: "",
      status: "",
      successMessage: "",
      errorMessage: "",
      isLoading: false,
      invoiceList: [],
      isDeleteModalOpen:false,
      invoice_id:""
    };
    this.setLoader = this.setLoader.bind(this);
  }

  componentDidMount = async() => {
    document.title = 'Invoices - TechToMedix';
   await this.props.fetchInvoiceList(
      this.state.searchKey,
      this.state.sortBy,
      this.state.page
    );
    if(this.props.invoiceListData && 
      this.props.invoiceListData.invoiceList && 
      this.props.invoiceListData.invoiceList.invoice){

        this.setState({
          invoiceList: this.props.invoiceListData.invoiceList.invoice
        })
    }
    setTimeout(() => {
      if (this.props.invoiceListData.invoiceList.total === 0) {
        this.setState({
          isDataFetched: true,
        });
      } else {
        this.setState({
          isDataFetched: false,
        });
        setTimeout(() => {
          this.setState({
            isDataFetched: true,
          });
        }, 500);
      }
    }, 1000);
  }

  callInvoiceListAPI = async() => {
    this.setState({
      invoiceList: []
    })
    
    const payload = this.getPayload();
    await this.props.fetchInvoiceList(
      this.state.searchKey,
      this.state.sortBy,
      this.state.page,
      payload
    );
    if(this.props.invoiceListData && 
      this.props.invoiceListData.invoiceList && 
      this.props.invoiceListData.invoiceList.invoice){

        this.setState({
          invoiceList: this.props.invoiceListData.invoiceList.invoice
        })
    }

    if(!this.props.invoiceListData.loading){
      this.setState({
        invoiceList: this.props.invoiceListData.invoiceList.invoice
      })
      setTimeout(() => {
        this.setState({
          isDataFetched: true,
        });
    }, 1000);
    }

  }
  // Adding actions edit and delete icons
  actionsFormatter(cell, row) {
    return (
      <div>
      {checkIfPermitted(Permissions.CAPTURE_INVOICE) && (
      <Link title="Edit Invoice" class="mr-2" to={{ pathname: `/app/createinvoice/${row.invoice_id}` }}>
        <i class="fa fa-pencil-square-o relatedpartylist-edit-icon mr-2"></i>
      </Link>)}
        {checkIfPermitted(Permissions.VIEW_INVOICE) && (
        <Link title="View Invoice" class="mr-2" to={{ pathname: `/app/invoicedetails/${row.invoice_id}` }}>
          <img class="mr-2" src={invoiceIcon} alt="invoice icon" width="15px" />
        </Link>)}
        {
          row.amount_paid===0 && (
            <Link title="Delete Invoice" 
            className="action-icons relatedpartylist-add-icon mr-2"
            onClick={() => this.toggleDeleteModal(row)}
          >
            <i className="fa fa-trash"></i>
          </Link>
          )
        }
       
      </div>
    );
  }

  onSortChange = (sortName, sortOrder) => {
    let sortBy;
    if (sortOrder == "desc") {
      sortBy = "-" + sortName;
    } else {
      sortBy = sortName;
    }
    this.setState({
      sortName,
      sortOrder,
      sortBy,
      page: 1,
      isDataFetched: false,
    },()=>{
      this.callInvoiceListAPI();
    });
  };

      /**
   * This will return payload object.
   */
  getPayload = () => {
    return {
    dateFrom: dateFormatter(this.state.dateFrom),
    dateTo: dateFormatter(this.state.dateTo),
    status: this.state.status
    };
  };
   
  /**
   * This method will be called when date from filter is changed.
   */
  handleDateFrom = (date) => {
    this.setState(
      {
        dateFrom: date,
        page: 1,
        isDataFetched: false,
      },
      () => {
        this.callInvoiceListAPI();
      }
    );
  };

  /**
   * This method will be called when date to filter is changed.
   */
  handleDateTo = (date) => {
    this.setState(
      {
        dateTo: date,
        page: 1,
        isDataFetched: false,
      },
      () => {
        this.callInvoiceListAPI();
      }
    );
  };


  onSearchChange = (event) => {
    this.setState({ searchKey: event.target.value, page: 1, isDataFetched: false },()=>{
      this.callInvoiceListAPI();
    });
  };

  onSelect = (event) => {
    this.setState({ status: event.target.value, page: 1, isDataFetched: false },()=>{
      this.callInvoiceListAPI();
    });
  };

  onPageChange = (page, sizePerPage) => {
    this.setState({ page, isDataFetched: false },()=>{
      this.callInvoiceListAPI();
    });
  };

  checkValidData = (data) => {
    if(!data){
      return "Not Available";
    }
    return data;
}

  setLoader() {
    if (this.state.isDataFetched) {
      return <p>There is no data to display</p>;
    } else {
      return (
        <div>
          <img src={ttmLoader} alt="loader" className="loader-image" />
        </div>
      );
    }
  }

  clearFilters = () => {
    this.setState({
      searchKey: "",
      sortBy: "",
      sortName: undefined,
      sortOrder: undefined,
      status: "",
      dateFrom: "",
      dateTo: "",
      page: 1,
      isDataFetched: false,
    },()=>{
      this.callInvoiceListAPI();
    });
  }

  // toggle modal poup for delete appointment from list
  toggleDeleteModal = (val) => {
    console.log('val',val)
    this.setState((prevState) => ({
      invoice_id: val.invoice_id,
      errorMessage: "",
      isDeleteModalOpen: !prevState.isDeleteModalOpen,
    }));
  };

 // Invoice delete API
  onInvoiceDelete = async () => {
        this.setState({
      isLoading: false,
      errorMessage: "" 
    });
    console.log('this.state',this.state)
    this.setState({
      isLoading: true
    })
    const payload={invoice_id:this.state.invoice_id}
    const headers = {
      Authorization:
        "Bearer " + JSON.parse(localStorage.getItem("USER_INFO")).token,
    };
    
    console.log('payload',payload)
    try {
        const response = await api.delete("payment/invoice/delete", {
          headers: headers,
          data: payload
        });

        if (response.status === 200) {
          this.setState({
            isLoading: false,
            successMessage: "Invoice delete successfully",
          });

          setTimeout(() => {
            this.setState((prevState) => ({
              successMessage: "",
              isDeleteModalOpen: !prevState.isDeleteModalOpen,
              isDataFetched: false
            }));
            this.callInvoiceListAPI();
          }, 3000);
        } 
        
   } catch(error){
     console.log(error.response.data.message)
    this.setState({
      isLoading: false,
      errorMessage:  error.response.data && error.response.data.message ? error.response.data.message :"Something went wrong! Please try again later"
    });
    
    // setTimeout(() => {
    //   this.setState({
    //     errorMessage: "",
    //   });
    // }, 3000);
   }
  }

  render() {
    const invoiceList = this.props.invoiceListData.invoiceList;

    
    const status_list = this.props.dropdownListData &&
    this.props.dropdownListData.dropdownList && this.props.dropdownListData.dropdownList.lk_invoice_status;

    const status_list_Options = status_list 
    && status_list.map((element, index) => (
     <option key={index} value={element.lk_invoice_status_id}>
       {element.status}
     </option>
   ));


    return (
      <div className={style.invoiceListMainWrapper}>
        <div className="row">
          {/* <div className="col-lg-7">
            <h3>Invoice List</h3>
          </div> */}
          <div
                className="col-sm-6 col-md-6 col-lg-3"
              >
               <div className="form-group">
                  <input
                    type="text"
                    className={`form-control ${style.inputSearch}`}
                    id="search"
                    placeholder="Search here"
                    value={this.state.searchKey}
                    onChange={this.onSearchChange}
                  />
                </div>
              </div>
              <div className="col-sm-6 col-md-6 col-lg-3">
              <DatePicker
                name="dateFrom"
                onChange={this.handleDateFrom}
                placeholder="Date From"
                className="form-control"
                value={this.state.dateFrom}
                disabledDate={(d) => !d || d.isAfter(this.state.dateTo)}
              />
            </div>

            <div className="col-sm-6 col-md-6 col-lg-3">
              <DatePicker
                name="dateTo"
                onChange={this.handleDateTo}
                placeholder="Date To"
                className="form-control"
                value={this.state.dateTo}
                disabledDate={(d) => !d || d.isBefore(this.state.dateFrom)}
              />
            </div>

            <div className="col-sm-6 col-md-6 col-lg-3">
              <select
                    className="form-control"
                    id="status"
                    onChange={this.onSelect}
                    value={this.state.status}
                  >
                    <option value="">Select Status</option>
                    {status_list_Options}
                  </select>
            </div>
            </div>
            <div className="row mb-1 d-flex">
            <div className="col-md-12 order-3 order-md-2 justify-content-md-end">
              <p className={style.clearFilters} onClick={this.clearFilters}>Clear Filters</p>
            </div>
            </div>
        <BootstrapTable
          bordered={false}
          remote={true}
          data={this.state.invoiceList}
          version="4"
          search={false}
          pagination
          fetchInfo={{
            dataTotalSize: this.props.invoiceListData.invoiceList.total,
          }}
          options={{
            sortName: this.state.sortName,
            sortOrder: this.state.sortOrder,
            onSortChange: this.onSortChange,
            onSearchChange: this.onSearchChange,
            sizePerPage: 10,
            page: this.state.page,
            onPageChange: this.onPageChange,
            noDataText: this.setLoader(),
          }}
        >
          <TableHeaderColumn dataField="invoice_number" isKey dataSort={true}>
            Invoice No.
          </TableHeaderColumn>
          <TableHeaderColumn dataField="billTo" dataSort={true}>
            Contact Name
          </TableHeaderColumn>
          <TableHeaderColumn 
          dataField="total" 
          dataAlign="right"
           dataFormat={formatNumberToCurrency} 
          dataSort={true}>
            Amount (ZAR)
          </TableHeaderColumn>
          <TableHeaderColumn
            dataField="invoice_date"
            dataSort={true}
            dataFormat={dateFormatter}
          >
            Date
          </TableHeaderColumn>
          <TableHeaderColumn
            dataField="status"
            dataSort={true}
            dataFormat={this.checkValidData}
            width="15%"
          >
            Status
          </TableHeaderColumn>

         { (checkIfPermitted(Permissions.VIEW_INVOICE) || checkIfPermitted(Permissions.CAPTURE_INVOICE)) && ( 
         <TableHeaderColumn
            dataField="actions"
            dataFormat={this.actionsFormatter.bind(this)}
            dataAlign="center"
            width="15%"
          >
            Actions
          </TableHeaderColumn>)}
        </BootstrapTable>
        {/* Open a modal for delete Appointment */}
        <Modal
          isOpen={this.state.isDeleteModalOpen}
          toggle={this.toggleDeleteModal}
          className={style.deleteReason}
          centered
        >
          <ModalHeader
            toggle={this.toggleDeleteModal}
            className={style.deleteModalHeader}
          >
            Delete Invoice
          </ModalHeader>
          <ModalBody>
            {!this.state.errorMessage && (
              <div className={style.deleteReasonHeadingWrapper}>
                <p>
                  Please confirm whether you want to delete this invoice.
                </p>
              </div>
            )}
            <div className={style.deleteReasonFormWrapper}>
              <form>
                <div className={style.error}>{this.state.errorField}</div>

                {!this.state.errorMessage && (
                  <div className="row">
                    <div className={`col-md-12 ${style.deleteBtnWrapper}`}>
                      <button
                        type="button"
                        className="ttm-primary-btn"
                        onClick={this.onInvoiceDelete}
                      >
                        Delete
                      </button>
                    </div>
                  </div>
                )}

                <div className="row">
                  <div className="col-md-12">
                    {this.state.successMessage && (
                      <p className={style.successMessage}>
                        {this.state.successMessage}
                      </p>
                    )}
                    {this.state.errorMessage && (
                      <p className={style.errorMessage}>
                        {this.state.errorMessage}
                      </p>
                    )}
                  </div>
                </div>
              </form>
            </div>
          </ModalBody>
        </Modal>

      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    invoiceListData: state.invoiceList,
    dropdownListData: state.dropdownList, 
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    fetchInvoiceList: (searchKey, sortBy, page, payload) =>
      dispatch(fetchInvoiceList(searchKey, sortBy, page, payload, 2)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(PatientInvoiceCash);
